import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

import { ConfigurationSecurity } from "@/model/data/security/ConfigurationSecurity";
import { ApiGenericResponse } from "../ApiGenericResponse";
const ENDPOINT = "/security/installation/configuration";

export class EditInstallationSecurityConfigurationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: EditInstallationSecurityConfigurationReqData;

    constructor(payload: EditInstallationSecurityConfigurationReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class EditInstallationSecurityConfigurationReqData {
    securityConfiguration: ConfigurationSecurity;
    installationName: string;
    editRools: boolean;
}
